//⚠️IMPACT gabarits consommés par formatRecurrenceRuleLabel (lib/recurrence-rule.ts) :
// les placeholders {interval}/{days}/{day}/{ordinal}/{weekday}/{until}/{count} sont
// interpolés par le formateur — ne pas les renommer sans adapter le formateur.
export const RecurrenceRuleLabelTranslation = {
  'fr-FR': {
    RECURRENCE_LABEL_DAILY: 'Chaque jour',
    RECURRENCE_LABEL_DAILY_PLURAL: 'Tous les {interval} jours',
    RECURRENCE_LABEL_WEEKLY: 'Chaque semaine',
    RECURRENCE_LABEL_WEEKLY_PLURAL: 'Toutes les {interval} semaines',
    RECURRENCE_LABEL_WEEKLY_DAYS_SUFFIX: ' le {days}',
    RECURRENCE_LABEL_EVERY_WEEKDAY: 'Tous les jours ouvrés (lun.–ven.)',
    RECURRENCE_LABEL_MONTHLY: 'Chaque mois',
    RECURRENCE_LABEL_MONTHLY_PLURAL: 'Tous les {interval} mois',
    RECURRENCE_LABEL_MONTHLY_DAY_SUFFIX: ' le {day}',
    RECURRENCE_LABEL_MONTHLY_LAST_DAY_SUFFIX: ' le dernier jour du mois',
    RECURRENCE_LABEL_MONTHLY_ORDINAL_SUFFIX: ' le {ordinal} {weekday}',
    RECURRENCE_LABEL_MONTHLY_WEEK_SUFFIX: ' la {week} semaine',
    RECURRENCE_LABEL_YEARLY: 'Chaque année',
    RECURRENCE_LABEL_YEARLY_PLURAL: 'Tous les {interval} ans',
    RECURRENCE_LABEL_UNTIL_SUFFIX: " jusqu'au {until}",
    RECURRENCE_LABEL_COUNT_SUFFIX: ', {count} fois',
    RECURRENCE_ORDINAL_1: '1er',
    RECURRENCE_ORDINAL_2: '2e',
    RECURRENCE_ORDINAL_3: '3e',
    RECURRENCE_ORDINAL_4: '4e',
    RECURRENCE_ORDINAL_LAST: 'dernier',
    // Ordinaux féminins pour « la {week} semaine » (accord avec « semaine »).
    RECURRENCE_WEEK_OF_MONTH_1: '1ère',
    RECURRENCE_WEEK_OF_MONTH_2: '2e',
    RECURRENCE_WEEK_OF_MONTH_3: '3e',
    RECURRENCE_WEEK_OF_MONTH_4: '4e',
    RECURRENCE_WEEK_OF_MONTH_LAST: 'dernière',
  },
};
